import * as yup from "yup";

import { APIMethods, ApiResponse } from "@typeDefinitions";
import { fetchData } from "@utils/api";

export const fetchProgramSection = async (
  programId: string,
  sectionId: string,
): Promise<ApiResponse<ProgramSectionDto>> => {
  const response = await fetchData(
    `/dietitian/programs/${programId}/sections/${sectionId}`,
    APIMethods.GET,
  );

  return responseSchema.validate(response);
};

interface ImageDto {
  id: number;
  url: string;
}

export interface ProgramSectionDto {
  id: number;
  title: string;
  titleEn: string | null;
  content: string | null;
  contentEn: string | null;
  isSystemic: boolean;
  image: ImageDto | null;
  description: string | null;
  descriptionEn: string | null;
}

const ImageSchema = yup.object({
  id: yup.number().required(),
  url: yup.string().required(),
});

const programSectionSchema = yup.object({
  id: yup.number().required(),
  title: yup.string().required(),
  titleEn: yup.string().nullable().default(null),
  content: yup.string().nullable().default(null),
  contentEn: yup.string().nullable().default(null),
  isSystemic: yup.boolean().required(),
  image: ImageSchema.nullable().default(null),
  description: yup.string().nullable().default(null),
  descriptionEn: yup.string().nullable().default(null),
});

const responseSchema = yup.object({
  data: programSectionSchema.required(),
});
